/* eslint-disable import/no-unresolved */

import React, { useRef, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { HrLabel, HrRed, HrParagraph, HrFlexContainer } from '@components/styles/hr-styles';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { HrSelect } from './select-search';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

export const SelectForm = ({
  width,
  title,
  id,
  data,
  onChangee,
  disabled,
  defaultValue,
  isSearchable,
  validate,
  formState,
  control,
  minWidth,
  isLoading,
  direction,
  placeholder,
  isMulti,
  errorPosition,
  filterOption,
  customValidate
}) => {
  const validateRegister = {};
  const { errors } = formState;
  const refCurrent = useRef(null);
  const [t] = useTranslation();
  if (validate.required || customValidate) {
    validateRegister.validate = {};
    if (validate.required) {
      validateRegister.validate.required = (value) => {
        if (Array.isArray(value)) {
          return value.length > 0 || t(`general.error.obligatoryField`);
        }

        return (value !== null && value !== undefined && value !== '') || t(`general.error.obligatoryField`);
      };
    }
    if (customValidate) {
      validateRegister.validate.custom = customValidate;
    }
  }
  const err = get(errors, id);
  useEffect(() => {
    if (err) {
      const firstError = Object.keys(errors).reduce((field, a) => {
        return !!errors[field] ? field : a;
      }, null);
      const splitName = id.split('.');
      const nameError = splitName.length > 1 ? splitName[0] : id;
      if (firstError === nameError) {
        refCurrent.current?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        refCurrent.current?.focus();
      }
    }
  }, [err]);

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer
      ref={refCurrent}
      flexDirection={direction}
      gap='8px'
      width={width}
      minWidth={minWidth}
      alignItems='flex-end'
    >
      {title && (
        <HrFlexContainer justifyContent='space-between'>
          <HrLabel
            fontSizeSetting={fontSizeSetting}
            htmlFor={id}
            isRequired={validate.required}
            userSelect='none'
            color={darkMode ? 'white' : ''}
          >
            {title}
          </HrLabel>
          {errorPosition === 'top' && (
            <ErrorMessage
              errors={errors}
              name={id}
              render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
            />
          )}
        </HrFlexContainer>
      )}
      <Controller
        control={control}
        name={id}
        defaultValue={defaultValue ?? null}
        rules={validateRegister}
        render={({ field }) => (
          <HrSelect
            data={data}
            darkMode={darkMode}
            selected={field.value}
            placeholder={placeholder}
            inputRef={field.ref}
            inputId={id}
            fontSizeSetting={fontSizeSetting}
            onChange={field.onChange}
            onClick={onChangee}
            isSearchable={isSearchable}
            isLoading={isLoading}
            disabled={disabled}
            formState={formState}
            filterOption={filterOption}
          />
        )}
      />
      {errorPosition === 'bottom' && (
        <ErrorMessage
          errors={errors}
          name={id}
          render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
        />
      )}
    </HrFlexContainer>
  );
};

SelectForm.propTypes = {
  id: PropTypes.string,
  data: PropTypes.array,
  onChangee: PropTypes.func,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  validate: PropTypes.object,
  formState: PropTypes.object,
  direction: PropTypes.string,
  width: PropTypes.string,
  placeholder: PropTypes.string,
  errorPosition: PropTypes.string,
  customValidate: PropTypes.func
};

SelectForm.defaultProps = {
  id: '',
  data: [],
  onChangee: () => {},
  onClick: () => {},
  validate: {},
  formState: { errors: {} },
  isLoading: false,
  direction: 'column',
  width: '100%',
  placeholder: 'Seleccione una opción',
  errorPosition: 'top',
  customValidate: null
};
